module.exports = __webpack_public_path__ + "static/Guillaume-6792740ea0b7924f402c4b1ee19f31ce.jpg";